import { STLineEndType } from '@tencent/slide-sdk-model';
import { LineEndType } from '@src/slide/infrastructure/module/dependent/line-info/endStyle';

// 箭头类型 - sdk对上层类型映射
export const LINE_END_TYPE_VER3_MAP = new Map([
    [STLineEndType?.none, LineEndType.NONE],
    [STLineEndType?.triangle, LineEndType.TRIAGNLE],
    [STLineEndType?.stealth, LineEndType.STEALTH],
    [STLineEndType?.diamond, LineEndType.DIAMOND],
    [STLineEndType?.oval, LineEndType.OVAL],
    [STLineEndType?.arrow, LineEndType.ARROW],
]);
